module.exports = __webpack_public_path__ + "static/media/Group.60af01a4.png";